import Menu from './Compartido/Menu.jsx';
import DatosPeticion from './Peticion/DatosPeticion.jsx';
import Footer from './Compartido/Footer.jsx';

const Peticion = (props) => {
    return (
        <main>

            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />

            <DatosPeticion
                propiedad={props.propiedad}
                llegada={props.llegada}
                salida={props.salida}
                difdias={props.difdias}
                adultos={props.adultos}
                ninos={props.ninos}
                bebes={props.bebes}
                ruta={props.ruta}
                numpropiedades={props.numpropiedades}
                websgrupo={props.websgrupo}
                precios={props.precios}
                moneda={props.moneda}
                lang={props.lang}
            />

            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default Peticion;
